import Router from 'next/router';
import { useCallback } from 'react';

import { type CloseAssetModalLocations, useTrackAssetModalClosed } from '@air/analytics';

import { getQueryWithNullAssetModalParams } from '~/components/AssetModalV2/utils';
import { pushWithExistingQuery } from '~/utils/PathUtils';

export type useCloseAssetModalProps = {
  trackLocation: CloseAssetModalLocations;
};

export const useCloseAssetModal = ({ trackLocation }: useCloseAssetModalProps) => {
  const { trackAssetModalClosed } = useTrackAssetModalClosed();
  const closeAssetModal = useCallback(() => {
    Router.ready(() => {
      const query = getQueryWithNullAssetModalParams();
      const pathname = Router.asPath.split('/c/')[0];
      return pushWithExistingQuery({
        path: pathname,
        newQuery: query,
      });
    });

    trackAssetModalClosed({ location: trackLocation });
  }, [trackAssetModalClosed, trackLocation]);

  return {
    closeAssetModal,
  };
};
